import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=7968b111&"
var script = {}
import style0 from "./Preloader.vue?vue&type=style&index=0&id=7968b111&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports